import { BaseDto } from "./base.dto"

import * as _ from 'lodash'

import { FileDto } from "./file.dto"
import { TenantCategoryDto } from "./tenant-category.dto"
import { PagingDto } from "./paging.dto"
import { TranslationDto } from "./translation.dto"
import { FloorMapDto } from "./floor-map.dto"
import { MallDto } from "./mall.dto"
import { ProductCategoryDto } from "./product-category.dto"
import { UserDto } from "./user.dto"
import { LocationDto } from "./location.dto"

export class TenantTypeDto {
  type: string
}

export class TenantDto extends BaseDto {
  name?: TranslationDto
  description?: TranslationDto
  location?: LocationDto
  paywayTenantId?: string
  telegramGroupId?: string
  logo?: FileDto
  cover?: FileDto
  mobileCover?: FileDto
  mall?: MallDto
  slug?: string
  enabled?: boolean
  adminEnabled?: boolean
  category?: TenantCategoryDto
  productCategories?: ProductCategoryDto[]
  mallId?: string
  contactNumber?: string
  floorMap?: FloorMapDto
  images?: FileDto
  mobileImages?: FileDto
  featuredCreatedAt?: Date
  whitelistedMid?: boolean
  isWhitelistSuccess?: boolean
  whitelistExisted?: boolean
  errorMessage?: string
  owners?: UserDto[]
  types?: TenantTypeDto[]
  selected?: boolean
  sortOrder?: number

  static create({ id, logo, name, paywayTenantId, owners, types, telegramGroupId, whitelistedMid, description, cover, category, mobileCover }: TenantDto) {
    return _.assign(new TenantDto(), {
      id: id || null,
      name: name || TranslationDto.create(),
      paywayTenantId,
      telegramGroupId,
      description: description || TranslationDto.create(),
      location: location || LocationDto.create(),
      mobileCover: mobileCover || null,
      category: category || null,
      logo: logo || null,
      cover: cover || null,
      whitelistedMid: whitelistedMid || null,
      owners: owners || [],
      types: types || []
    })
  }

  static update() {
    return new TenantDto()
  }
}

export class SortOrderTenantDto {
  tenantId: string
  sortOrder: number
}

export class CreateTenantDto {
  name: TranslationDto
  description: TranslationDto
  locationId?: string
  paywayTenantId?: string
  telegramGroupId?: string
  categoryId: string
  productCategoryIds: string[]
  types: string[]
  logoId: string
  coverId: string
  mobileCoverId: string
  mallId?: string
}

export class UpdateTenantDto {
  name?: TranslationDto
  description?: TranslationDto
  locationId?: string
  paywayTenantId?: string
  telegramGroupId?: string
  categoryId?: string
  productCategoryIds?: string[]
  logoId?: string
  coverId?: string
  mobileCoverId?: string
  mallId?: string
  adminEnabled?: boolean
  contactNumber?: string
  types?: string[]
}

export class FindTenantDto extends PagingDto {
  searchText?: string
  hasFloorMap?: string
}

export class MerchantUpdateTenantDto {
  name?: TranslationDto
  description?: TranslationDto
  locationId?: string
  logoId?: string
  coverId?: string
  mobileCoverId?: string
  adminEnabled?: boolean
  contactNumber?: string
}

export class AdminUpdateTenantResponseDto {
  isWhitelistSuccess: boolean
  whitelistExisted: boolean
  errorMessage: string
}